import { ActivityType } from "@hshrimal/salesleg";
export const activityTypeDisplayMap = new Map<ActivityType, string>([
  ["call", "Call"],
  ["email", "Email"],
  ["meeting", "Meeting"],
  ["message", "Message"],
  ["site_visit", "Site Visit"],
]);
